import React, { useEffect, useState } from "react";
//import { Button } from "semantic-ui-react";
//import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
//import { useParams } from "react-router-dom";
import styles from './BillingPayNow.module.scss';
import { useAppSelector } from "../../../hooks/hooks";
import { TBillingState } from "../Billing.interfaces";


const BillingPayNow: React.FC = () => {
    // const { payOption } = useParams<{ payOption: string }>();
    // const [isLoading, setIsLoading] = useState<boolean>(false)
    // const dispatch = useAppDispatch();
    // const { payOption } = useAppSelector(state => state.payOption)
    const billing: TBillingState = useAppSelector(state => state.Billing);

    return (
        <div className={styles.page}>
            {billing.payOption === 'by' ?
                <iframe width="100%" height="100%" title="Pay Now" style={{ borderRadius: '8px' }}
                    src="https://www.liqpay.ua/api/3/checkout?data=eyJ2ZXJzaW9uIjozLCJhY3Rpb24iOiJwYXkiLCJhbW91bnQiOiIxMDAiLCJjdXJyZW5jeSI6IkVVUiIsImRlc2NyaXB0aW9uIjoiYWNjZXNzIHRvIGh0dHBzOi8vc3BvcnRkYXRhY29sbGVjdGlvbi5jb20iLCJwdWJsaWNfa2V5IjoiaTg4NTAyMzY4MzMxIiwibGFuZ3VhZ2UiOiJlbiIsInNlcnZlcl91cmwiOiJodHRwczovL2FwaS5zcG9ydGRhdGFjb2xsZWN0aW9uLmNvbS9hcGkvYmlsbGluZy9saXFwYXktY2FsbGJhY2siLCJyZXN1bHRfdXJsIjoiaHR0cHM6Ly9zcG9ydGRhdGFjb2xsZWN0aW9uLmNvbS9iaWxsaW5nL3BheW1lbnQtcmVzdWx0In0=&signature=UYxSHD/nR1PvmtQLeTiPlYw6KpY="
                />
                :
                <iframe width="100%" height="100%" title="Pay Now" style={{ borderRadius: '8px' }}
                    src="https://www.liqpay.ua/api/3/checkout?data=eyJ2ZXJzaW9uIjozLCJhY3Rpb24iOiJwYXkiLCJhbW91bnQiOiIxMCIsImN1cnJlbmN5IjoiRVVSIiwiZGVzY3JpcHRpb24iOiJhY2Nlc3MgdG8gaHR0cHM6Ly9zcG9ydGRhdGFjb2xsZWN0aW9uLmNvbSIsInB1YmxpY19rZXkiOiJpODg1MDIzNjgzMzEiLCJsYW5ndWFnZSI6ImVuIiwic2VydmVyX3VybCI6Imh0dHBzOi8vYXBpLnNwb3J0ZGF0YWNvbGxlY3Rpb24uY29tL2FwaS9iaWxsaW5nL2xpcXBheS1jYWxsYmFjayIsInJlc3VsdF91cmwiOiJodHRwczovL3Nwb3J0ZGF0YWNvbGxlY3Rpb24uY29tL2JpbGxpbmcvcGF5bWVudC1yZXN1bHQifQ==&signature=r54gQGaF4S+69J7fNmy18KIqbq4="
                />
            }
        </div>
    );
}

export default BillingPayNow;